<div class="header-logo-container">
  <a class="header-logo" href="{{ redirectLink }}">
    <img src="assets/img/universia-red.svg" alt="Logo Universia" />
  </a>
</div>

<button
  *ngIf="userLogged"
  class="header-button my-account-primary-link--m"
  (click)="doLogout()"
>
  <em class="fas fa-power-off"></em>
  <span class="header-button-text">{{ 'sso.dologout' | translate }}</span>
</button>
